module.exports = __webpack_public_path__ + "img/lka.497ee5b9.svg";